import Outbox from './Outbox.vue';

const routes = [
  {
    path      : '/outbox/:step?',
    name      : 'Outbox',
    component : Outbox,
    props     : true
  }
];

export default routes;
